<template>
  <div v-cloak class="my-profile-contailer">
    <div class="caret-square">
      <i class="fa fa-arrow-circle-left cursor fa-2x" aria-hidden="true" @click="$router.go(-1);"></i>
      &nbsp;
      <span class="title">{{this.$route.query.title}}</span>
    </div>

    <el-dialog
      title="Store Pictures"
      :visible.sync="confirmToShowPicturesDialogVisible"
      :close-on-click-modal="true"
      :center="true">
      <div class="dialog">
        <img src="https://sfa.itfsm.com/image-shower/73003E1E626C42A3A98BBDB3F965C939.jpg"/>

      </div>
      <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="confirmToShowPicturesDialogVisible = false">Close</el-button>
            </span>
    </el-dialog>

    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ path:'/home' }"><i class="fa fa-home"></i> Home</router-link>
        </li>
        <li>
          <small> {{this.$route.query.name}}</small>
        </li>
        <li class="active">
          <small>Process detail</small>
        </li>
      </ol>
    </div>

    <div class="area-store-information">
      <span><b>Banner Information</b></span>
      <div  class="store-information">
        <banner-information :bannerId="this.$route.query.id"></banner-information>
      </div>
    </div>
    <div v-html="myHtml"></div>
    <div class="area-store-pictures"  v-loading="dataLoading"
         element-loading-text="Loading, please wait..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <span><b >Process</b> &nbsp;&nbsp;&nbsp;&nbsp; <a v-show ="imgSrc" @click="openNewPage" >Open in New Page </a></span>



      <div  class="store-pictures" v-show="imgSrc">
        <div @click="openNewPage">
          <iframe id="imgIframe" title="Process preview" style="width: 100%;height: 600px"></iframe>
        </div>

      </div>

      <div v-show="!imgSrc" class="store-pictures">
        <div id ="errorMsg">Loading ...</div>

      </div>




    </div>



  </div>
</template>

<script>
  import bannerInformation from '@/view/store/banner_master/banner_information.vue'
  import util from '@/util/util.js'

  export default {
    components: {
      bannerInformation,
    },
    data() {
      return {
        prevPageName: '',
        confirmToShowPicturesDialogVisible: false,
        imgSrc: '',
        dataLoading: false,
        myHtml:''
      }
    },
    computed: {},
    created() {

    },
    mounted(){
      this.getProcessDetail();
    },


    methods: {

      getProcessDetail(){

        if(this.$route.query.piId){
          let url = this.baseStoreUrl + '/dms/workflow/getProcessInstanceDiagramPage?byStream=true&proccessInstanceId=' + this.$route.query.piId;
          this.http.get(url).then( resp => {
            let blob = new Blob([resp.data], {
              type: "text/html",
            });
            console.log(blob,'blob')
            if(blob.size > 1000) {
              let url = window.URL.createObjectURL(blob);
              this.imgSrc = url;
              $("#imgIframe").attr("src", url);
            } else {
              $("#errorMsg").html("若无法显示流程图，请尝试多次刷新页面后可显示");
              this.imgSrc = "";
            }

            // let data = resp.data;
            // let fileId = data.fileId;
            // if (fileId) {
            //   let url = baseSSO.download_file_url + fileId;
            //   $("#imgIframe").attr("src", url);
            //   this.imgSrc = url;
            // } else {
            //   $("#errorMsg").html("若无法显示流程图，请尝试多次刷新页面后可显示");
            //   this.imgSrc = "";
            // }
          }).catch(function (e) {
            $("#errorMsg").html("Picture not found")
            console.error(e);
          });
        }else{
          $("#errorMsg").html('piId not found, this may be initialization data');
        }
      },
      openNewPage(){
        let url = this.imgSrc;
        window.open(url,'_blank');
      }
    }

  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }


  .my-profile-contailer {
    padding: 10px;
  }

  .title {
    font-size: 20px;
  }

  .caret-square {
    margin-left: 15px;
  }

  .content-wrapper /deep/ .content {
    padding: 0px;
    margin-top: -18px;
    margin-left: -10px;
  }
  .store-information{
    margin-top: -25px;
  }
  .area-store-information{
    background-color: white;
    padding: 10px;
  }

  .area-store-pictures{
    margin-top: 10px;
    background-color: white;
    padding: 10px;
  }
  .store-pictures{
    text-align: center;
    color: red;
  }

  /deep/ .el-image-viewer__canvas{
    background-color: white;
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/view/store/banner_master/banner_process_detail.vue